import { createAPIHeaders, fetchUtility } from '.';

export const deleteOperation = async (apiKey: string, operationName: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/deleteOperation/${operationName}`, {
		headers: createAPIHeaders(apiKey, 'DELETE'),
		method: 'DELETE',
	});
};

export const deleteOperationData = async (apiKey: string, operationName: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/eks/deleteOperationData/${operationName}`, {
		headers: createAPIHeaders(apiKey, 'DELETE'),
		method: 'DELETE',
	});
};

export const deleteKeywordFile = async (apiKey: string, id: string, orgId: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/eks/deleteKeywordFile/${id}/${orgId}`, {
		headers: createAPIHeaders(apiKey, 'DELETE'),
		method: 'DELETE',
	});
};
